// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"_3d-7s4e"};